// import placeHolder from './../../../images/placeholderLarge.jpg';

export default function imgLazyLoaderLarge() {
  return {
    restrict: 'A',
    scope: {
      imgLazyLoaderLarge: '@',
      bgImg: '@'
    },
    link: (scope, element) => { /*
      if (scope.bgImg) {
        let elem = angular.element('<img />').attr('src', scope.imgLazyLoaderLarge);
        element.css('background-image', 'url(' + placeHolder + ')');
        elem.one('load', () => {
          elem.remove();
          element.css('background-image', 'url(' + scope.imgLazyLoaderLarge + ')');
        });
      }
      else {
        element.attr('src', placeHolder);
        element.one('load', () => {
          element.attr('src', scope.imgLazyLoaderLarge);
        });
        element.one('error', () => element.attr('src', placeHolder));
      }
    */ }
  };
}



// WEBPACK FOOTER //
// ./src/app/components/img-lazy-loader-large/directive.js